/* eslint-disable import/prefer-default-export */
import DashMarvinJS from './components/DashMarvinJS.react';

export {
    DashMarvinJS
};
